import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "18",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "M15.332.871h-1.048a3.144 3.144 0 0 0-3.145 3.144v7.337a1.05 1.05 0 0 0 1.049 1.048h1.048v4.193a1.047 1.047 0 0 0 1.048 1.047h1.048a1.047 1.047 0 0 0 1.049-1.047V1.919A1.05 1.05 0 0 0 15.332.87m0 10.481v5.24h-1.048v-5.24h-2.096V4.015a2.1 2.1 0 0 1 2.096-2.096h1.048zM7.472.872a.524.524 0 0 0-.524.523V7.16H4.85V1.395a.523.523 0 1 0-1.048 0V7.16H1.707V1.395a.523.523 0 1 0-1.048 0v6.812a2.093 2.093 0 0 0 2.096 2.097v6.289a1.047 1.047 0 0 0 1.048 1.047h1.048a1.05 1.05 0 0 0 1.048-1.047v-6.289a2.095 2.095 0 0 0 2.096-2.097V1.395A.524.524 0 0 0 7.471.87M5.898 9.255H4.851v7.337H3.803V9.256H2.755a1.05 1.05 0 0 1-1.048-1.049h5.24A1.05 1.05 0 0 1 5.9 9.256"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }